import React from 'react';
// import Cards from './components/Cards/Cards';
// import Chart from './components/Charts/Chart';
// import CountryPicker from './components/CountyPicker/CountryPicker';
import {Cards,Chart,CountryPicker} from './components';
import styles from './App.module.css';
import {fetchData} from './api/index';
import covid from './assets/covid19_logo.png';

class App extends React.Component{
  state = {
    data:{},
    country:'',
  }

  async componentDidMount() {
    const fetchedData = await fetchData();
    this.setState({data:fetchedData});
  }
handleCountryChange = async (country) => {
  const fetchedData = await fetchData(country);
  this.setState({ data : fetchedData, country: country});
}

  render() {
    const { data, country } = this.state;
    return (
      <div className={styles.container}>
        <img className={styles.covid} src={covid} alt="covid" />
        <Cards data = {data}/>
        <CountryPicker handleCountryChange= {this.handleCountryChange} />
        <Chart data = {data} country = {country} />
        <div className={styles.footer}>
        <p>Copyright © 2020 | Hemalatha Jampula</p>
        </div>
        
       
      </div>
    )
  }
}

export default App;
